import React, { PureComponent } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class DefaultSourceModal extends PureComponent {
  state = {
    selectedSource: null,
  }

  onClose = () => {
    this.setState({})
  }

  onOpen = (type) => {
    this.setState({})
  }

  onChange = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  setDefault = () => {
    const { selectedSource } = this.state
    this.props.setDefault(selectedSource)
  }

  render() {
    const { forwardedRef, sourceList } = this.props
    const { selectedSource } = this.state

    return (
      <ModalDialog
        title={'Set Default Payment Source'}
        ref={forwardedRef}
        onConfirm={this.setDefault}
        // onClose={this.onClose}
        // onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Payment Source</InputLabel>
          <Select value={selectedSource} onChange={this.onChange('selectedSource')}>
            {sourceList.map((row, index) => {
              return (
                <MenuItem key={index} value={row.value}>
                  {row.label}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(DefaultSourceModal)



// WEBPACK FOOTER //
// ./src/components/Modal/DefaultSourceModal.js